<template>
    <v-card class="statisticsDonutComponent pa-3 pt-0" style="max-height: 550px;">
        <v-card-title>
            {{ $t("title_" + dataKey) }}
            <infoTooltip v-if="tooltip" :tooltip="tooltip" />
        </v-card-title>
        <v-card-text class="card-content">
            <v-skeleton-loader v-if="stats[dataKey] === undefined" type="article"></v-skeleton-loader>

            <div v-else-if="graphData.datasets && graphData.labels.length" class="donut-container">
                <DonutComponent :key="donutKey" :dataSet="graphData" :legend="false" style="height: 200px;"/>

                <div class="legend-config-container">
                    <v-simple-table class="legend-table" dense>
                        <template v-slot:default>
                            <tbody>
                                <tr v-for="(legend, index) in graphData.labels">
                                    <td><span :style="'width: 20px; height:20px; display:inline-block; background-color:' + graphData.datasets[0].backgroundColor[index]"></span></td>
                                    <td><b>{{ legend }}</b></td>
                                    <td class="text-right"><b class="mr-2">{{ graphData.datasets[0].data[index] }}</b><small>{{ (100 * graphData.datasets[0].data[index] / getDataTotal(graphData.datasets[0].data)).toFixed(2) }}%</small></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </div>
            
            <v-alert class="mb-0" border="left" color="info" v-else text>
                {{ $t("emptyDataMessage") }}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import DonutComponent from '@/components/graphs/DonutComponent';
import infoTooltip from '@/components/infoTooltip';
export default {
    name: "statisticsDonutComponent",
    props: ["stats", "dataKey", "tooltip", "to_trad", "colors"],
    components: { DonutComponent, infoTooltip },
    data() {
        return {
            donutKey: 0,
            graphData: {},
            predefinedColors: [
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
        }
    },
    watch: {
        stats: {
            handler() {
                this.generateGraphData();
            },
            deep: true,
        }
    },
    methods: {
        generateRandomColor() {
            // Générer une couleur hexadécimale aléatoire
            return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
        },
        generateGraphData() {
            this.donutKey++;
            if(this.stats && this.stats[this.dataKey] !== undefined) {
                let labels = Object.keys(this.stats[this.dataKey]);

                if(this.to_trad) {
                    labels = labels.map(label => this.$t(label));
                }

                // Générer les couleurs selon les règles
                const dataLength = Object.keys(this.stats[this.dataKey]).length;
                let backgroundColors = [];

                if (this.colors && this.colors.length >= dataLength) {
                    // Si des couleurs personnalisées sont fournies et suffisantes, les utiliser
                    backgroundColors = this.colors.slice(0, dataLength);
                } else {
                    // Sinon, utiliser la logique des 20 couleurs prédéfinies + couleurs aléatoires
                    if (dataLength <= 20) {
                        // Si 20 données ou moins, utiliser les couleurs prédéfinies dans l'ordre
                        backgroundColors = this.predefinedColors.slice(0, dataLength);
                    } else {
                        // Si plus de 20 données, utiliser les 20 couleurs prédéfinies + couleurs aléatoires
                        backgroundColors = [...this.predefinedColors];
                        for (let i = 20; i < dataLength; i++) {
                            backgroundColors.push(this.generateRandomColor());
                        }
                    }
                }

                this.graphData = {
                    "labels": labels,
                    "datasets": [{
                        "data": Object.values(this.stats[this.dataKey]),
                        "backgroundColor": backgroundColors
                    }]
                }
            }
        },
        getDataTotal(datas) {
            return datas.reduce((a, b) => parseInt(a) + parseInt(b), 0);
        }
    },
}
</script>

<style lang="scss">
    .statisticsDonutComponent {
        display: flex;
        flex-direction: column;
        
        .card-content {
            overflow: hidden;
            display: flex;
            flex-direction: column;
            flex: 1;
            
            .donut-container {
                display: flex;
                flex-direction: column;
                flex: 1;
                overflow: hidden;
                
                .legend-config-container {
                    flex: 1;
                    overflow-y: auto;
                    padding-right: 8px; // Pour éviter que la légende touche le bord droit
                    
                    // Style de la scrollbar pour Chrome/Edge/Safari
                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    
                    &::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 3px;
                    }
                    
                    &::-webkit-scrollbar-thumb {
                        background: #c1c1c1;
                        border-radius: 3px;
                        
                        &:hover {
                            background: #a8a8a8;
                        }
                    }
                }
            }
        }
        
        td:first-child { 
            width: 25px;
        }
    }
</style>